import HeroSection from '../../../components/HeroSection';
import WhatSetsUsApartSection from './components/WhatSetsUsApartSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import TrainingSection from './components/TrainingSection';
import ClientPortalSection from './components/ClientPortalSection';
import TeamSection from './components/TeamSection';
import AccessClientPortal from './components/AccessClientPortal';
import FaqQuickList from '../../../components/FaqQuickList';
import { PageWrapper } from '../../../components/Layouts/PageWrapper';
import { HERO_CONTENT } from './constants';
import { openSimplePracticeConsultation } from '../../../utils/simplePractice';

const Practitioners = () => {
  const handleBookConsultation = () => {
    openSimplePracticeConsultation();
  };

  return (
    <PageWrapper>
      <HeroSection {...HERO_CONTENT}  onContainedButtonClick={handleBookConsultation}/>
      <WhatSetsUsApartSection />
      <TeamSection />
      <HowWeWorkSection />
      <FaqQuickList />
      <TrainingSection />
      <AccessClientPortal />
      <ClientPortalSection />
    </PageWrapper>
  );
};

export default Practitioners;
